<script setup>

import SlideoutWithSlots from "../elements/slideoutWithSlots.vue";
import {computed, ref} from "vue";

const emit = defineEmits(['reload'])

const props = defineProps({
    leads: {
        type: Array,
        required: false,
        default: () => []
    },
})

const tagSlideoutOpen = ref(false)
const deleteSlideoutOpen = ref(false)

const modalClass = computed(() => {
    if (tagSlideoutOpen.value || deleteSlideoutOpen.value) {
        return 'top-8 translate-y-0 opacity-0'
    }
    return props.leads.length > 0 ? 'top-8 translate-y-0' : 'top-0 -mt-48 -translate-y-full'
})

const onDeleted = () => {
    deleteSlideoutOpen.value = false
    emit('deleted')
}

</script>

<template>
    <div>
        <div
            class="fixed transition-all left-1/2 -translate-x-1/2 z-modal"
            :class="modalClass"
        >
            <div class="bg-white shadow-2xl rounded-wl p-2 pl-3">
                <p class="text-center text-xs mb-2">{{ leads.length }} leads selected</p>
                <div class="grid grid-cols-2 gap-4">
                    <div class="flex justify-center">
                        <button-primary
                            size="sm"
                            @click="tagSlideoutOpen = true"
                        >
                            Add tags
                        </button-primary>
                    </div>
                    <div class="flex justify-center">
                        <button-danger
                            size="sm"
                            @click="deleteSlideoutOpen = true"
                        >
                            Delete leads...
                        </button-danger>
                    </div>
                </div>
            </div>

            <slideout-with-slots
                v-if="tagSlideoutOpen"
                @close="tagSlideoutOpen = false"
            >
                <template #title>
                    <h2>Manage {{ leads.length }} leads</h2>
                </template>
                <template #body>
                    <div>
                        <tags-multi-assign
                            :showTopbar="false"
                            :selected-leads="leads.map(lead => lead.id)"
                        />
                    </div>
                </template>
            </slideout-with-slots>

            <slideout-with-slots
                v-if="deleteSlideoutOpen"
                @close="deleteSlideoutOpen = false"
            >
                <template #title>
                    <h2>Delete {{ leads.length }} leads</h2>
                </template>
                <template #body>
                    <div>
                        <tags-multi-delete
                            :selected-leads="leads"
                            @deleted="onDeleted"
                        />
                    </div>
                </template>
            </slideout-with-slots>

        </div>
    </div>
</template>
